import { EnumItemDto } from "approot/global/models/common.model";

export enum Role
{
	Admin = "Admin",
	Principal = "Principal",
	Teacher = "Teacher",
	Student = "Student",
	Parent = "Parent",
	MinorStaff = "MinorStaff",
	Secretary = "Secretary",
	MedicalStaff = "MedicalStaff",
	Psychologist = "Psychologist",
	SpecialistStaff = "SpecialistStaff",

	EmAdmin = "EmAdmin",
	EMHDEM = "EMHDEM",
	EmOFREM = "EmOFREM",
	EmOper = "EmOper",
	EmCoordOD = "EmCoordOD",
	EmCoordMer = "EmCoordMer",
	EmExtObs = "EmExtObs"
}

export enum Right
{
	arProfileEditSchoolInfo				= "arProfileEditSchoolInfo",
	arProfileViewSchoolInfo				= "arProfileViewSchoolInfo",
	arProfileEditRegionalSettings		= "arProfileEditRegionalSettings",
	arProfileDefineSecurityRoles		= "arProfileDefineSecurityRoles",
	arEditReferenceBook					= "arEditReferenceBook",
	arEditSchoolSettings				= "arEditSchoolSettings",

	// Редактировать все сведения о сотрудниках
	arUsersEditStaff = "arUsersEditStaff",

	arUsersEditStaffMedInfo				= "arUsersEditStaffMedInfo",

	// Редактировать все сведения об учениках и родителях
	arUsersEditStudents = "arUsersEditStudents",

	arUsersEditStudentsMedInfo			= "arUsersEditStudentsMedInfo",
	arUsersEditStudentsPsyInfo			= "arUsersEditStudentsPsyInfo",

	// Редактировать имена пользователей и пароли сотрудников
	arUsersEditAccountStaff = "arUsersEditAccountStaff",

	// Редактировать имена пользователей и пароли учеников и родителей
	arUsersEditAccountStudentsParents = "arUsersEditAccountStudentsParents",

	arUsersEditAccountStudentsParentsInClass = "arUsersEditAccountStudentsParentsInClass",

	arCreateCloseEditYear				= "arCreateCloseEditYear",
	arSchoolSubjects					= "arSchoolSubjects",
	arCreateEditTerm					= "arCreateEditTerm",
	arEditSchoolTermTypes				= "arEditSchoolTermTypes",
	arMoveBookView						= "arMoveBookView",
	arMoveBookEdit						= "arMoveBookEdit",
	arMovePoolStudents					= "arMovePoolStudents",
	arMovePoolStaff						= "arMovePoolStaff",
	arMoveRequests						= "arMoveRequests",

	arSchoolDocsView					= "arSchoolDocsView",
	arSchoolDocsEdit					= "arSchoolDocsEdit",

	arClassMgmViewClassSubjAll			= "arClassMgmViewClassSubjAll",
	arClassMgmCreateClass				= "arClassMgmCreateClass",
	arClassMgmEditSubjects				= "arClassMgmEditSubjects",
	arClassMgmEnrollClass				= "arClassMgmEnrollClass",

	// Право определять мероприятия в своём классе/группе>
	arClassMgmPostClassEventSelf		= "arClassMgmPostClassEventSelf",

	// Право определять мероприятия во всех классах/группах
	arClassMgmPostClassEventAll			= "arClassMgmPostClassEventAll",

	arCurrMgmViewSelf					= "arCurrMgmViewSelf",
	arCurrMgmViewAll					= "arCurrMgmViewAll",
	arCurrMgmCreate						= "arCurrMgmCreate",
	arCurrMgmCreateAll					= "arCurrMgmCreateAll",
	arAddLA								= "arAddLA",

	arCalendarViewSelf					= "arCalendarViewSelf",
	arCalendarViewAll					= "arCalendarViewAll",
	arCalendarCreateCalendar			= "arCalendarCreateCalendar",
	// Определять мероприятия ОО, каникулы, праздники
	arPostSchoolEvent					= "arPostSchoolEvent",
	arViewAwardEvents					= "arViewAwardEvents",
	arPostAwardEvents					= "arPostAwardEvents",
	arEditAwardEventMembers				= "arEditAwardEventMembers",

	arViewSelfAwardEvents				= "arViewSelfAwardEvents",
	arSelfRegisterForAwardEvents		= "arSelfRegisterForAwardEvents",
	arEditSelfAwardEventResults			= "arEditSelfAwardEventResults",

	arJournalViewSelf					= "arJournalViewSelf",
	arJournalViewAll					= "arJournalViewAll",
	arJournalEditSelf					= "arJournalEditSelf",
	arJournalEditAll					= "arJournalEditAll",
	arJournalEditHAOnlyOnFuture			= "arJournalEditHAOnlyOnFuture",
	arTotalsViewSelf					= "arTotalsViewSelf",
	arTotalsViewAll						= "arTotalsViewAll",
	arTotalsEditSelf					= "arTotalsEditSelf",
	arTotalsEditAll						= "arTotalsEditAll",
	// Задавать настройки учебных курсов
	arLASetPolicies						= "arLASetPolicies",

	// Задавать оценочные шкалы
	arLACreateGradingScales				= "arLACreateGradingScales",
	// Просматривать материал учебных курсов
	arLAViewMaterials					= "arLAViewMaterials",
	// Редактировать задания и оценки по учебным курсам для своей группы/класса/объединения или предмета
	arLAEditSelf						= "arLAEditSelf",
	// Просматривать задания и оценки по учебным курсам для своей группы/класса/объединения или предмета
	arLAViewSelf						= "arLAViewSelf",
	// Просматривать задания и оценки по учебным курсам для всех групп/классов/объединений
	arLAViewAll							= "arLAViewAll",

	// Просмотр отчетов для своих групп/классов/объединений
	arReportsForAssignedClass			= "arReportsForAssignedClass",
	// Просматривать отчеты во всех группах/классах/объединениях
	arReportsForAllClasses				= "arReportsForAllClasses",
	// Просматривать отчеты в своей группе/классе/объединении
	arReportsViewForAssignedClass		= "arReportsViewForAssignedClass",
	// Просматривать дополнительные отчеты
	arReportsViewAdditionalReports		= "arReportsViewAdditionalReports",
	// Использовать конструктор отчетов
	arReportsUseReportConstructor		= "arReportsUseReportConstructor",
	// Просмотр административных отчётов
	arReportsViewAdministrativeReports	= "arReportsViewAdministrativeReports",

	arAnnouncementView					= "arAnnouncementView",
	arAnnouncementPost					= "arAnnouncementPost",
	arMessagesSendReceive				= "arMessagesSendReceive",
	arForumSendReceive					= "arForumSendReceive",
	arForumEdit							= "arForumEdit",
	arAssignmentsViewComplete			= "arAssignmentsViewComplete",

	arShortInfoStaff					= "arShortInfoStaff",
	arShortInfoStudents					= "arShortInfoStudents",
	arEditInfoSelf						= "arEditInfoSelf",
	arEnrollSelf						= "arEditInfoSelf",

	arDeleteUsers						= "arDeleteUsers",

	arEditSchoolResources				= "arEditSchoolResources",
	arSetPhoto							= "arSetPhoto",

	arBrowseResultsEGEAllClasses			= "arBrowseResultsEGEAllClasses",
	arBrowseResultsEGEHisClassesOrSubjects	= "arBrowseResultsEGEHisClassesOrSubjects",
	arSchoolPublicDocsView					= "arSchoolPublicDocsView",

	arBrowseStatReports						= "arBrowseStatReports",
	arFillStatReports						= "arFillStatReports",

	arBrowseAccessJournal					= "arBrowseAccessJournal",
	arUserStat								= "arUserStat",

	/* Индивидуальная поддержка обучающихся */
	arIndividualSupportStudentsReestrView = "arIndividualSupportStudentsReestrView",	// Просмотр реестра учащихся индивидуальной поддержки
	arAddIndividualSupportStudents = "arAddIndividualSupportStudents",		// Добавление учащихся в систему индивидуальной поддержки
	arIndividualSupportMeasuresEditAll = "arIndividualSupportMeasuresEditAll",    // Редактирование мероприятий индивидуальной поддержки.Всех мероприятий
	arIndividualSupportMeasuresEditSelf = "arIndividualSupportMeasuresEditSelf",	// Редактирование мероприятий индивидуальной поддержки.Своих мероприятий

	// Просматривать отчеты по детям с особыми образовательными потребностями
	arReportsViewSpecialEducNeeds = "arReportsViewSpecialEducNeeds",

	arViewHealthMonitoring = "arViewHealthMonitoring",
	arEditHealthMonitoring = "arEditHealthMonitoring",

	arViewFoodPayOrders = "arViewFoodPayOrders",
	arEditFoodPayOrders = "arEditFoodPayOrders",

	arEditFoodPayStudentOrdersAll = "arEditFoodPayStudentOrdersAll",
	arEditFoodPayStudentOrdersSelf = "arEditFoodPayStudentOrdersSelf",

	arEditFoodPayBalanceAll = "arEditFoodPayBalanceAll",
	arEditFoodPayBalanceSelf = "arEditFoodPayBalanceSelf",

	arPostFoodPayStudentOrders = "arPostFoodPayStudentOrders",
	arFoodPayPayment = "arFoodPayPayment",
	arFormAndSignParentsReferences = "arFormAndSignParentsReferences",

	arAddMonitoringDiagnostic = "arAddMonitoringDiagnostic",
	arEditMonitoringDiagnostic = "arEditMonitoringDiagnostic",
	arViewMonitoringDiagnostic = "arViewMonitoringDiagnostic",
	arDeleteMonitoringDiagnostic = "arDeleteMonitoringDiagnostic",


	// #17155. EM rights.
	arEMUsersView = "arEMUsersView",
	arEMUsersEdit		  = "arEMUsersEdit",
	arEMEventsView		  = "arEMEventsView",
	arEMEventsEdit		  = "arEMEventsEdit",
	arEMReports			  = "arEMReports",
	arEMPersonDataReports = "arEMPersonDataReports",
	arEMAddReportsView	  = "arEMAddReportsView",
	arEMAddReportsEdit	  = "arEMAddReportsEdit",
	arEMMovement		  = "arEMMovement",
	arEMStats			  = "arEMStats",
	arEMEgeView			  = "arEMEgeView",
	arEMEgeImport		  = "arEMEgeImport",
	arEMMsoko			  = "arEMMsoko",
	arEMDouPayNormView 	  = "arEMDouPayNormView",
	arEMDouPayNormEdit 	  = "arEMDouPayNormEdit",

	arEMCuratorsODView		= "arEMCuratorsODView",
	arEMCuratorsODEdit		= "arEMCuratorsODEdit",
	arEMODView				= "arEMODView",
	arEMODEdit				= "arEMODEdit",
	arEMEventsMembersView	= "arEMEventsMembersView",
	arEMEventsMembersEdit	= "arEMEventsMembersEdit",
	arEMOrganizationsAdministration	= "arEMOrganizationsAdministration",
}

export interface SchoolRoleRightDto
{
	role: Role,
	right: Right
}

export interface RightEnumItemDto extends EnumItemDto {
	group: EnumItemDto,
	subgroup: EnumItemDto,
	includedRoles: Role[],
	excludedRoles: Role[],
	rules: boolean[]
}

export interface NonEditableRight {
	right: Right,
	value: boolean
}

// группа/панель прав
export interface GroupRights {
	group?: EnumItemDto,
	subgroups?: SubgroupRights[]
}

// подгруппа прав
export class SubgroupRights {
	constructor(public subgroup: EnumItemDto, public rights: RightEnumItemDto[]) {
		this.prepare();
	}

	private prepare() {
		if (this.isList()) {
			this.rights = this.rights.sort((a, b) => a.order - b.order);
		}
	}

	isList(): boolean {
		return !!this.subgroup && this.rights.length > 1 ||
			(this.rights.length == 1 && this.rights[0].key == Right.arIndividualSupportMeasuresEditSelf);
	}
}

export interface GroupSettings extends GroupRights {
	id: string,
	title: string,
	settings: Setting[]
}

export interface ValidateRule {
	message: string;
	setting: Setting,
	validate(): boolean;
}

export class MinValidateRule implements ValidateRule {
	constructor(
		public min: number,
		public setting: Setting,
		public message: string
	) {
	}

	validate(): boolean {
		return this.setting.value >= this.min;
	}
}

export interface Setting {
	title: string,
	value: any,
	validateRules?: ValidateRule[]
}

export interface GridInfo {
	cols: number,
	colRows: number[],
	gridGroups: GroupRights[][]
}

export interface SecurityRightsArgs {
	role: Role,
	rights: Right[],
	logoutTime?: number
}

export interface RightDto {
	right?: Right,
	timeLimit?: number,
	isLogoutTimeSetting?: boolean,
	logoutTime?: number
}
